<app-device-parameter-form
  [parameters$]="pidParameters$"
  [showApplyButton]="true"
  [showSubmit]="true"
  submitText="APPLY CONTROL VALUES"
>
</app-device-parameter-form>
